module.exports = __webpack_public_path__ + "img/technologyImg2.55c80c96.png";